/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AnalyticDescription } from '../model/models';
import { AnalyticDescriptionType } from '../model/models';
import { AnalyticFilterData } from '../model/models';
import { AnalyticFilterDefinition } from '../model/models';
import { AnalyticFilterTypeInputField } from '../model/models';
import { AnalyticFiltertype } from '../model/models';
import { AnalyticLegend } from '../model/models';
import { AnalyticLegendEntry } from '../model/models';
import { AnalyticMeasure } from '../model/models';
import { AnalyticMeasureType } from '../model/models';
import { AnalyticProcess } from '../model/models';
import { AnalyticProcessGroup } from '../model/models';
import { AnalyticProcessNavigation } from '../model/models';
import { AnalyticValue } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface AnalyticsServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Get analyticDescriptionType by ID
     * Returns analyticDescriptionType by ID
     * @param id ID of analyticDescriptionType
     */
    getAnalyticDescriptionTypeById(id: number, extraHttpRequestParams?: any): Observable<AnalyticDescriptionType>;

    /**
     * Get a list of IDs depending on an input field for a specific AnalyticProcess
     * Returns a list of IDs depending on an input field for a specific AnalyticProcess
     * @param analyticProcessId ID of the analytic process
     */
    getAnalyticFilterDefinitionByProcessIdListForInputFields(analyticProcessId: number, extraHttpRequestParams?: any): Observable<Array<AnalyticFilterTypeInputField>>;

    /**
     * Get the current AnalyticLegend for a specific analyticProcessID
     * Returns the current AnalyticLegend for a specific analyticProcessID. The ID of the analytic process is required as a parameter for the method.
     * @param analyticProcessId ID of the analytic process
     */
    getAnalyticLegendByAnalyticProcessId(analyticProcessId: number, extraHttpRequestParams?: any): Observable<Array<AnalyticLegend>>;

    /**
     * Get the current analyticLegendEntry.
     * Returns a list of the current analyticLegendEntry ordered by sort.
     */
    getAnalyticLegendEntry(extraHttpRequestParams?: any): Observable<Array<AnalyticLegendEntry>>;

    /**
     * Returns analyticMeasureType by ID.
     * Returns analyticMeasureType by ID.
     * @param id ID of analyticMeasureType
     */
    getAnalyticMeasureTypeById(id: number, extraHttpRequestParams?: any): Observable<AnalyticMeasureType>;

    /**
     * Returns analytic process by ID
     * Returns analytic process by ID
     * @param analyticProcessId ID of the analytic process
     */
    getAnalyticProcessById(analyticProcessId: number, extraHttpRequestParams?: any): Observable<AnalyticProcess>;

    /**
     * An AnalyticProcessGroup by Id
     * Returns the AnalyticProcessGroup with all belonging AnalyticProcesses
     * @param analyticProcessGroupId ID of the analytic process group
     */
    getAnalyticProcessGroupById(analyticProcessGroupId: number, extraHttpRequestParams?: any): Observable<AnalyticProcessGroup>;

    /**
     * A List of all analytic process groups
     * Returns the analytic processes groups with the analytic processes that belong to them
     */
    getAnalyticProcessGroups(extraHttpRequestParams?: any): Observable<Array<AnalyticProcessGroup>>;

    /**
     * TODO
     * TODO
     */
    getAnalyticProcessNavigation(extraHttpRequestParams?: any): Observable<Array<AnalyticProcessNavigation>>;

    /**
     * Get current analytic description by analyticProcessID
     * This endpoint returns the current analytic description for the specific analyticProcessID. The ID of the analytic process is required as a parameter for this method. 
     * @param analyticProcessId ID of the analytic process
     */
    getCurrentAnalyticDescriptionByProcessId(analyticProcessId: number, extraHttpRequestParams?: any): Observable<Array<AnalyticDescription>>;

    /**
     * Get current analytic description types
     * Returns a list of all AnalyticDescriptionType that are visible and ordered by \&quot;sort\&quot;. Show all AnalyticDescriptionType that have \&quot;isVisible\&quot; &#x3D; 1 and order them by \&quot;sort\&quot;. 
     */
    getCurrentAnalyticDescriptionType(extraHttpRequestParams?: any): Observable<Array<AnalyticDescriptionType>>;

    /**
     * Get current analyticFilterData by analyticProcessID
     * Returns a list of AnalyticFilterData for a specific analyticProcessID.
     * @param analyticProcessId ID of the analytic process
     */
    getCurrentAnalyticFilterDataByProcessId(analyticProcessId: number, extraHttpRequestParams?: any): Observable<Array<AnalyticFilterData>>;

    /**
     * Get current AnalyticFilterDefinition_Type by analyticProcessID
     * Returns a merged list of AnalyticFilterDefinition and the associated AnalyticFilterType for a specific analyticProcessID.
     * @param analyticProcessId ID of the analytic process
     */
    getCurrentAnalyticFilterDefinitionByProcessId(analyticProcessId: number, extraHttpRequestParams?: any): Observable<Array<AnalyticFilterDefinition>>;

    /**
     * Get the current AnalyticFilterType list
     * Returns a list of the current AnalyticFilterType.
     */
    getCurrentAnalyticFilterType(extraHttpRequestParams?: any): Observable<Array<AnalyticFiltertype>>;

    /**
     * Returns the running analyticMeasure.
     * Returns a list of the AnalyticMeasure for a specific analyticProcessID.
     * @param analyticProcessId ID of the analytic process
     */
    getCurrentAnalyticMeasureByProcessId(analyticProcessId: number, extraHttpRequestParams?: any): Observable<Array<AnalyticMeasure>>;

    /**
     * Returns the running analyticMeasureType.
     * Returns a list of all AnalyticMeasureType that are visible and ordered by sort. Show all AnalyticMeasureType that have \&quot;isVisible\&quot; &#x3D; 1 and order them by \&quot;sort\&quot;.
     */
    getCurrentAnalyticMeasureType(extraHttpRequestParams?: any): Observable<Array<AnalyticMeasureType>>;

    /**
     * A list of the analytic process.
     * Returns a list with all analytic processes.
     */
    getCurrentAnalyticProcess(extraHttpRequestParams?: any): Observable<Array<AnalyticProcess>>;

    /**
     * Returns a list of analytic values.
     * Returns a list of analytic values.
     */
    getCurrentAnalyticValue(extraHttpRequestParams?: any): Observable<Array<AnalyticValue>>;

}
